import { Pencil } from "lucide-react";

interface InvoiceBasicInformationProps {
  invoice: {
    recipient_name: string;
    address?: string | null;
    phone?: string | null;
    invoice_no: string;
    invoice_date: string;
    sales_name: string;
    po_number?: string | null;
    customer_id?: string | null;
    total_payment_due: number;
    delivery_time: string;
    due_date: string;
    createdAt: string;
  };
  onEdit: () => void;
}

const formatCurrency = (value: number) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(value || 0);

const formatDate = (value: string) =>
  new Intl.DateTimeFormat("id-ID", { day: "2-digit", month: "2-digit", year: "numeric" }).format(
    new Date(value)
  );

export default function InvoiceBasicInformation({ invoice, onEdit }: InvoiceBasicInformationProps) {
  return (
    <div className="rounded-2xl border border-gray-100 p-5">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="font-semibold">Basic Information</h3>
        <button
          onClick={onEdit}
          className="flex items-center gap-1 rounded-lg bg-blue-100 px-3 py-1.5 text-sm font-medium text-blue-600 hover:bg-blue-200">
          <Pencil size={14} />
          Edit Quotation
        </button>
      </div>

      <div className="grid grid-cols-2 gap-x-10 gap-y-2 text-sm">
        <Row label="Bill To" value={invoice.recipient_name} />
        <Row label="Sales Name" value={invoice.sales_name} />

        <Row label="Address" value={invoice.address || "-"} />
        <Row label="PO Number" value={invoice.po_number || "-"} />

        <Row label="Phone" value={invoice.phone || "-"} />
        <Row label="Customer ID" value={invoice.customer_id || "-"} />

        <Row label="No Invoice" value={invoice.invoice_no} />
        <Row label="Due Date" value={formatDate(invoice.due_date)} />
        <Row
          label="Total Payment Due"
          value={formatCurrency(invoice.total_payment_due)}
        />

        <Row label="Date" value={formatDate(invoice.invoice_date)} />
        <Row label="Delivery Time" value={invoice.delivery_time} />
      </div>

      <p className="mt-4 flex items-center gap-1 text-xs text-gray-400">
        Create at {new Date(invoice.createdAt).toLocaleDateString("id-ID")}{" "}
        {new Date(invoice.createdAt).toLocaleTimeString("id-ID", {
          hour: "2-digit",
          minute: "2-digit",
        })}{" "}
        WIB
      </p>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex">
      <span className="w-36 shrink-0 text-gray-500">{label}</span>
      <span className="mr-2">:</span>
      <span className="font-medium text-gray-800">{value}</span>
    </div>
  );
}
